import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConfigService } from '../../reactive-forms/services/app-config.service';
import { SharedHandlersService } from '../shared-handlers.service';
import { SBHttpServicesService } from './sbhttp-services.service';
import { async } from 'q';
import Swal from 'sweetalert2';

@Injectable()
export class BuildPreCachedURlsService {
    public ScreenData;
    constructor(private httpService: SBHttpServicesService, public activatedRoute: ActivatedRoute,
        private environment: AppConfigService, public Shared: SharedHandlersService) {

    }
    Screens: any = [];;
     ngOninit() {
    }
    public urls = [ ];

    //loadWorkWith() {
    //    this.BuildPreCachedUrlsSchemaDynmaic();
    //    let parameter = this.activatedRoute.snapshot.paramMap.get('ID');
    //    var screenvalues = await this.metaDataService.GetScreenData(screenData.ScreenDataSource[0]["ScreenDataSourceId"],
    //        parameter, 0, 10);
    //    this.BuildPreCachedUrls(parameter, screenvalues.map(s => s.CustomerNo));
    //}

     PreCachedService() {
         for (var i = 0; i < this.urls.length; i++) {
              this.httpService.httpGetRequest(this.urls[i],"",false);
        }
    }
    //steps 
    // 1- btn start call lst of CustomerNo list of string 
    //2- function 
    // input Lst=["0005116","0005117"]
    // build urls 
    // call preCached Service 


    BuildPreCachedUrls(CallID: string, customer) {
        let CallId = CallID.substring(CallID.indexOf(':') + 1, CallID.length);
        for (var i = 0; i < customer.length; i++) {
            this.urls.push(this.environment.apiRoot + 'api/Supervisor/GetObjectiveByCallId/'+ CallId);
            this.urls.push(this.environment.apiRoot + 'api/supervisor/GetCustomerFeedback/' + CallId + '/' + customer[i]);
            this.urls.push(this.environment.apiRoot + 'api/schema/GetScreenData/122/0/10/CustomerNo:' + customer[i] + '&&CallID:'+ CallId);
            this.urls.push(this.environment.apiRoot + 'api/schema/GetScreenData/123/0/10/CustomerNo:' + customer[i] + '&&CallID:' + CallId);
            this.urls.push(this.environment.apiRoot + 'api/schema/GetScreenData/124/0/10/CustomerNo:' + customer[i] + '&&CallID:' + CallId);
            this.urls.push(this.environment.apiRoot + 'api/schema/GetScreenData/125/0/10/CustomerNo:' + customer[i] + '&&CallID:' + CallId);

        }
       
         this.PreCachedService();
    }


   async BuildPreCachedUrlsSchemaDynmaic() {
    //    this.Screens = await this.httpService.httpGetRequest(this.environment.apiRoot + "api/schema/GetOfflineScreens");
    //    if (this.Screens && this.Screens["status"] && this.Screens["status"] == 2) {
    //     Swal.fire({
    //         html: `<div>Error</div><div style=font-size:15px>${this.Screens["message"]}</div>`,
    //         showCloseButton: true,
    //         background: '#fff url(assets/images/block_black_24dp.svg) center center no-repeat',
    //         showConfirmButton: false
    //       });
    //        return;
    //    }
    //    for (var i = 0; i < this.Screens.length; i++) {
    //         this.urls.push(this.environment.apiRoot + 'api/schema/GetScreenAttributes/' + this.Screens[i].ScreenId);
    //     }
        //this.PreCachedService();
    }



}
